<template>
  <div>
    <input type="checkbox" class="checkbox" :value="state.id" v-model="stateValue" @change="submitValue">
    <span class="label_title ">{{state.name}}</span>
  </div>
</template>

<script>
export default {
    props: ['state', 'selectAll'],
    data() {
        return {
            stateValue: ''
        }
    },
    methods: {
        submitValue() {
            this.$emit('stateValue', this.state.id)
        }
    },
    watch: {
        selectAll() {
           if(this.selectAll) {
               this.stateValue = true
           } else {
               this.stateValue = false
           }
        }
    }
}
</script>

<style>

</style>